import React from 'react'
import "./App.css";

function StreamPlayer(props) {
  return (
     <iframe 
        style={{
          width: "100%",
          height: "50%"
        }} 
        src="https://home-server.avi-portfolio.net/camfeed/" 
     />
  )
}

export default StreamPlayer;